import BaseService from "@/boot/BaseService";
class BcraService extends BaseService {
  constructor() {
    super(null, "/bcra");
  }
  async getDeudas(cuit) {
    return await this.get(`/deudas/${cuit}`);
  }

}

export default new BcraService();
